<template>
  <button :class="btnClasses">{{ label }}</button>
</template>
<script setup lang="ts">
import { computed } from 'vue'

type Props = {
  label: string
  active?: boolean
  disabled?: boolean
}
const props = defineProps<Props>()

const btnClasses = computed(() => {
  const baseClass = 'flex items-center w-full h-24 px-8 transition-2 ellipsis text-small-semibold'
  const colorClass = props.disabled
    ? 'text-gray-20 bg-gray-5'
    : props.active
      ? 'text-primary-50 bg-white'
      : 'text-gray-70 bg-gray-5'
  const cursorClass = props.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
  return [baseClass, colorClass, cursorClass].join(' ')
})
</script>
